export default __webpack_public_path__ + "files/ncsa_logo-e7796c45842d8a1081971e5f97e47860.png";